import { observer } from 'mobx-react-lite';
import { useEffect, useMemo } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { FormioForm } from 'src/components/FormioForm/FormioForm';
import { SpinnerFullWidth } from 'src/components/Spinner/SpinnerFullWidth';
import { RoutePaths } from 'src/core/router/RoutePaths';
import { Router } from 'src/core/router/Router';
import { SettingsNotificationTemplatesStore } from 'src/stores/SettingsStores/SettingsNotificationTemplatesStore/SettingsNotificationTemplatesStore';
import { SettingsRoutes } from 'src/stores/SettingsStores/SettingsPageStore/ListApplicationSettings';
import { CombinedLoadingStatus } from 'src/utils/mobx/CombinedLoadingStatus';

export const NotificationTemplateEdit = observer(() => {
    const { params, url } = useRouteMatch<{ id: string }>();
    const { id } = params;

    useEffect(() => {
        store.loadForm(store.itemEditFormKey);
        store.loadItem(id);

        return () => {
            store.formLoader.reset();
        };
    }, []);

    const loadingStatus = useMemo(() => {
        return new CombinedLoadingStatus([store.formLoader, store.itemLoader]);
    }, []);

    if (loadingStatus.isLoading) {
        return <SpinnerFullWidth />;
    }

    return (
        <FormioForm
            key={`${id}-edit`}
            form={store.currentItemForm as any}
            submission={{ data: store.currentItem } as any}
            onCustomEvent={async (event) => {
                if (
                    event.type === 'startProcess' &&
                    (event.component as any).properties?.processKey
                ) {
                    const processKey = (event.component as any).properties
                        ?.processKey;
                    Router.navigate(`${url}/process/${processKey}`);
                } else if (event.type === 'cancel') {
                    Router.navigate(notificationTemplateListUrl);
                } else if (event.type === 'save') {
                    await store.update(id, event.data);
                    Router.navigate(notificationTemplateListUrl);
                }

                return Promise.resolve();
            }}
            onSubmit={async (submission) => {
                await store.update(id, submission.data);
                Router.navigate(notificationTemplateListUrl);
            }}
        />
    );
});
const store = SettingsNotificationTemplatesStore;

const notificationTemplateListUrl = `${RoutePaths.settings}/${SettingsRoutes.notificationTemplates}`;
